import React from 'react';
import { ApolloProvider } from '@apollo/client';
import * as Sentry from '@sentry/react-native';
import * as Device from 'expo-device';
import { theme } from 'gradoo-theme';
import { Dimensions, Platform } from 'react-native';
import { GestureHandlerRootView } from 'react-native-gesture-handler';
import { Host } from 'react-native-portalize';
import {
  SafeAreaProvider,
  SafeAreaInsetsContext,
} from 'react-native-safe-area-context';
import { ThemeProvider } from 'styled-components/native';
import WebDeprecationBanner from './components/WebDeprecationBanner';
import { AuthProvider } from './context/auth';
import { IntercomProvider } from './context/intercom';
import client from './data/client';
import RootNavigation, { navigationIntegration } from './navigation';
const { width, height } = Dimensions.get('window');

const isMobile = Platform.OS !== 'web';

Sentry.init({
  dsn: 'https://fc0a999c7d534550a0b53a0c06fb8494@o697731.ingest.sentry.io/5776572',
  enabled: !__DEV__,
  tracesSampleRate: 0.4,
  beforeSend(event) {
    event.tags = {
      ...event.tags,
      deviceYearClass: Device.deviceYearClass,
    };
    return event;
  },
  integrations: [navigationIntegration],
  tracePropagationTargets: ['localhost', 'gradoo.app'],
});

function App(): JSX.Element {
  return (
    <GestureHandlerRootView style={{ flex: 1 }}>
      <ApolloProvider client={client}>
        <SafeAreaProvider>
          <SafeAreaInsetsContext.Consumer>
            {(insets) => (
              <ThemeProvider
                theme={{
                  ...theme,
                  safeAreaInsets: insets || theme.safeAreaInsets,
                  dimensions: {
                    screenHeight: height,
                    screenWidth: width,
                  },
                }}
              >
                <IntercomProvider>
                  <AuthProvider>
                    <Host>
                      <WebDeprecationBanner />
                      <RootNavigation />
                    </Host>
                  </AuthProvider>
                </IntercomProvider>
              </ThemeProvider>
            )}
          </SafeAreaInsetsContext.Consumer>
        </SafeAreaProvider>
      </ApolloProvider>
    </GestureHandlerRootView>
  );
}

export default isMobile ? Sentry.wrap(App) : App;
